<script lang="ts">
  import { Support } from "@tastyworks/icons-2.0"
  import { _ } from "svelte-i18n"
  import { getCobrowseSessionContext } from "./session-store.svelte"

  interface Props {
    mobile?: boolean
    onError?: (error: unknown) => void
  }

  let { mobile = false, onError }: Props = $props()

  const session = getCobrowseSessionContext()
</script>

{#if mobile}
  <button
    type="button"
    class="text-general-secondary-text font-small-400 flex flex-col items-center gap-2 disabled:opacity-50"
    disabled={session.sessionLoading || !!session.sessionCode}
    onclick={() => session.requestSessionCode(onError)}
  >
    <Support class="size-6" />
    <div class="flex flex-col items-center">
      <span>
        {#if session.sessionCode}
          {session.sessionCode.slice(0, 3)} {session.sessionCode.slice(3)}
        {:else}
          {session.sessionLoading
            ? $_("cobrowse.buttonLoading")
            : $_("cobrowse.buttonMobile")}
        {/if}
      </span>
      <span
        class="font-small-400"
        class:invisible={!session.sessionCode}
        aria-hidden={!session.sessionCode}
      >
        {$_("cobrowse.codeInstructions")}
      </span>
    </div>
  </button>
{:else if session.sessionCode}
  <div>
    <p>
      {$_("cobrowse.codeLabel")}
      {session.sessionCode.slice(0, 3)}
      {session.sessionCode.slice(3)}
    </p>
    <p class="text-general-secondary-label">
      {$_("cobrowse.codeInstructions")}
    </p>
  </div>
{:else}
  <button
    type="button"
    class="flex items-center gap-1 disabled:opacity-50"
    disabled={session.sessionLoading}
    onclick={() => session.requestSessionCode(onError)}
  >
    {session.sessionLoading
      ? $_("cobrowse.buttonLoading")
      : $_("cobrowse.buttonDefault")}
    {#if !session.sessionLoading}
      <Support class="icon-large w-5" />
    {/if}
  </button>
{/if}
